import { Button, Col, Dropdown, Icon, Layout, Menu, message, Modal, Row } from "antd";
import moment from "moment";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { bindActionCreators } from "redux";
import { purgeStoredState } from "redux-persist";
import storage from "redux-persist/lib/storage";
import ChangePassword from "../src/modules/auth/pages/login/components/change-password";
import { actionCreators as authCreators } from "../src/modules/auth/reducer";
import LoadingComponent from "./commons/loader";
import { actionCreators as themeActionCreators } from "./commons/ThemeManager/reducer";
import projects from "./utils/propertyData";
import { deleteToken, deleteUserAct, getUserAct, setUserAct } from "./utils/token";



const { Content, Footer, Header, Sider } = Layout;
const { SubMenu } = Menu;

const mainNavigation = [
  {
    name: "Resources",
    link: "/dashboard/resources"
  },
  {
    name: "Brands",
    link: "/dashboard/brands"
  },
  {
    name: "Resources",
    link: "/dashboard/calendar"
  }
];

class App extends Component {
  constructor(props) {
    super(props);
    this.setWrapperRef = this.setWrapperRef.bind(this);
  }

  state = { logoutVisible: false, changePasswordModal: false, isClear: false };

  static propTypes = {
    isAuthenticated: PropTypes.bool.isRequired,
    // user: PropTypes.object.isRequired,
    children: PropTypes.node.isRequired
  };

  onCollapse = collapsed => {
    this.setState({ collapsed });
  };

  showModal = () => {
    this.setState({
      logoutVisible: true
    });
  };
  showChangeModal = () => {
    this.setState({
      changePasswordModal: true,
      isClear: false
    });
  };
  cancelChangeModal = e => {
    this.setState({
      changePasswordModal: false
    });
  };
  onOk = () => {
    const persistConfig = {
      key: "rlsp",
      storage
    };

    const authPersistConfig = {
      key: "rlspauth",
      storage
    };
    this.props.logout();
    deleteToken();
    purgeStoredState(persistConfig);
    purgeStoredState(authPersistConfig);
    window.location.href = "/"; 
  };

  hideModal = () => {
    this.setState({
      logoutVisible: false
    });
  };

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  componentDidMount() {
    this.props.resetTheme();

    if (this.props.children.props.match.path === "/") {
      document.removeEventListener("mousedown", this.checkInActivityUser);
    } else {
      this.checkInActivityUser();
      setUserAct(moment().format());
      document.addEventListener("mousedown", this.checkInActivityUser);
    }
  }
  componentDidUpdate(prevProps) {
    const { isChangingPassword, changePasswordData } = this.props;

    if (prevProps.changePasswordData !== changePasswordData) {
      if (changePasswordData.length !== 0) {
        if (changePasswordData[1] === "error") {
          if (this.props.isAuthenticated) {
            message.error(changePasswordData[2]);
          }
        } else {
          if (this.props.isAuthenticated) {
            message.success(changePasswordData[2]);

            this.setState({
              changePasswordModal: false,
              isClear: true
            });
          }
        }
      }
    }
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.checkInActivityUser);
  }
  handeSubmitChangePassword = e => {
    //submit to change password
    e.agentId = this.props.profile.Partner;

    this.props.changePassword(e);
  };
  checkInActivityUser = () => {
    let self = this;
    const { isAuthenticated } = self.props;
    let currentTime = moment().format();
    let lastActivityTime = getUserAct();

    let durationInMinutes = moment
      .duration(moment(currentTime).diff(lastActivityTime))
      .minutes();

    console.log(`Last activity: ${durationInMinutes} minutes ago`);
    if (
      durationInMinutes >= 15 &&
      isAuthenticated &&
      lastActivityTime !== null
    ) {
      document.removeEventListener("mousedown", this.checkInActivityUser);
      Modal.warning({
        title: "Session Expired!",
        content: "Your session has expired due to inactivity.",
        onOk() {
          self.onOk();
        }
      });
    } else {
      setUserAct(moment().format());
    }
  };

  autoLogOut = () => {
    const persistConfig = {
      key: "rlsp",
      storage
    };

    const authPersistConfig = {
      key: "rlspauth",
      storage
    };

    deleteToken();
    deleteUserAct();
    purgeStoredState(persistConfig);
    purgeStoredState(authPersistConfig);
  };

  render() {
    const {
      isAuthenticated,
      isLoading,
      selectedTheme,
      selectedSubMenu,
      selectedMenu,
      selectMenu,
      openSubMenu,
      selectedProperty,
      profile,
      isCustomer
    } = this.props;

    let project = {};

    if (selectedProperty) {
      project = projects.find(
        item => item.property_id == selectedProperty.property_code
      )
        ? projects.find(
          item => item.property_id == selectedProperty.property_code
        )
        : {};
    }
    if (isAuthenticated) {
      if (isLoading) {
        return <LoadingComponent isLoading={isLoading} />;
      }
      // for rbank payment page for payment gateway
      if (window.location.pathname === "/dashboard/reservation/rbank/process") {
        return (
          <Content>
            {React.cloneElement(this.props.children, { ...this.props })}
          </Content>
        );
      }

      const mainHeaderNavigation = (
        <Menu mode="horizontal">
          <Menu.Item key="1" style={{ marginBottom: "6px" }}>
            {!isCustomer ? (
              <Button href="/dashboard/customer-360/lead" type="primary">
                + Add New Leads
              </Button>
            ) : null}
          </Menu.Item>
          <SubMenu
            key="sub1"
            title={
              <Row type="flex" align="middle" gutter={5}>
                <Col>
                  {profile ? profile.Firstname : ""}{" "}
                  {profile ? profile.Lastname : ""}
                </Col>
                <Col>
                  <Icon type="down" style={{ fontSize: ".6rem" }} />
                </Col>
              </Row>
            }
          >
            <Menu.Item key="2" onClick={this.showModal}>
              <Icon type="logout" /> Signout
            </Menu.Item>
            {!isCustomer ? (
              <Menu.Item key="3" onClick={this.showChangeModal}>
                <Icon type="setting" /> Change Password
              </Menu.Item>
            ) : null}
          </SubMenu>
        </Menu>
      );

      const mainHeaderOverlayNavigation = (
        <Menu mode="horizontal">
          {!isCustomer ? (
            <Menu.Item key="1" style={{ marginBottom: "6px" }}>
              <a href="/dashboard/customer-360/lead">+ Add New Leads</a>
            </Menu.Item>
          ) : null}
          <Menu.Item key="2" onClick={this.showModal}>
            <Icon type="logout" /> Signout
          </Menu.Item>
        </Menu>
      );

      return (
        <Layout ref={this.setWrapperRef} className="dashboard">
          <Header className="main-header">
            <Row className="logo-container">
              <img
                src="/assets/images/rlc-logo_2.jpg"
                alt="logo"
                className="logo"
              />
            </Row>
            <Row className="responsive-header-navigation">
              {mainHeaderNavigation}
              <Dropdown overlay={mainHeaderOverlayNavigation}>
                <Button type="link">
                  <Icon type="align-right" />
                </Button>
              </Dropdown>
            </Row>
          </Header>
          <Layout>
            <Header className="sub-header">
              {!isCustomer ? (
                <Menu
                  mode="horizontal"
                  defaultSelectedKeys={["/dashboard/brands"]}
                  selectedKeys={[window.location.pathname]}
                  overflowedIndicator={
                    <Row type="flex" justify="center" gutter={10}>
                      {/* <Col>
                      {window.location.pathname
                        .split("/")[1]
                        .replace(/-/g, " ")}
                    </Col> */}
                      <Col>
                        <Icon type="caret-down" />
                      </Col>
                    </Row>
                  }
                >
                  <Menu.Item key="/dashboard/resources">
                    <NavLink to="/dashboard/resources">RESOURCES</NavLink>
                  </Menu.Item>
                  <Menu.Item key="/dashboard/brands">
                    <NavLink to="/maintenance">
                      <Row type="flex" gutter={5}>
                        <Col style={{ width: "100%" }}>PROJECTS</Col>
                        {/* <Col>
                        <Icon type="down" theme="outlined" />
                      </Col> */}
                      </Row>
                    </NavLink>
                  </Menu.Item>
                  {/* <Menu.Item key="/dashboard/availability">
                <NavLink to="/dashboard/availability">
                  AVAILABILITY
                </NavLink>
              </Menu.Item> */}
                  <Menu.Item key="/dashboard/calendar">
                    <NavLink to="/dashboard/calendar">MY DASHBOARD</NavLink>
                  </Menu.Item>
                </Menu>
              ) : null}
            </Header>
            <Layout>
              {selectedTheme === "sidebar" && selectedProperty ? (
                <Sider
                  width={250}
                  style={{ background: "#EDF4F9" }}
                  breakpoint="lg"
                  collapsedWidth="0"
                  onCollapse={(collapsed, type) => {
                    console.log(collapsed, type);
                  }}
                >
                  <h1 className="sidebar-header">
                    {selectedProperty.property_name}
                  </h1>

                  <Menu
                    className="project-details-sider"
                    theme="light"
                    mode="inline"
                    defaultSelectedKeys={selectedMenu}
                    selectedKeys={selectedMenu}
                    openKeys={selectedSubMenu}
                    onSelect={selectMenu}
                    onOpenChange={openSubMenu}
                  >
                    <Menu.Item key="1">
                      <NavLink
                        to={`/dashboard/brands/${selectedProperty.brand.code}/projects/${selectedProperty.property_code}`}
                        className="nav-text"
                      >
                        <span>Project Overview</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="2">
                      <NavLink
                        to={`/dashboard/brands/${selectedProperty.brand.code}/projects/${selectedProperty.property_code}/locations`}
                        className="nav-text"
                      >
                        <span>Location</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="3">
                      <NavLink
                        to={`/dashboard/brands/${selectedProperty.brand.code}/projects/${selectedProperty.property_code}/building-details`}
                        className="nav-text"
                      >
                        <span>Building Details</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="4">
                      <NavLink
                        to={`/dashboard/brands/${selectedProperty.brand.code}/projects/${selectedProperty.property_code}/amenities`}
                        className="nav-text"
                      >
                        <span>Amenities</span>
                      </NavLink>
                    </Menu.Item>
                    <SubMenu
                      key="5"
                      title={
                        <span>
                          <span>Floor Plans</span>
                        </span>
                      }
                    >
                      {selectedProperty.information.building_details
                        .residential_units
                        ? selectedProperty.information.building_details.residential_units.map(
                          (building, index) => (
                            <Menu.Item key={`floor-${index}`}>
                              <NavLink
                                to={`/dashboard/brands/${selectedProperty.brand.code}/projects/${selectedProperty.property_code}/floor-plans/${building.building_code}`}
                              >
                                <span>{building.building_code}</span>
                              </NavLink>
                            </Menu.Item>
                          )
                        )
                        : null}
                    </SubMenu>
                    <SubMenu
                      key="8"
                      title={
                        <span>
                          <span>Unit Details</span>
                        </span>
                      }
                    >
                      {selectedProperty.information.building_details
                        .residential_units
                        ? selectedProperty.information.building_details.residential_units.map(
                          (building, index) => (
                            <Menu.Item key={`unit-${index}`}>
                              <NavLink
                                to={`/dashboard/brands/${selectedProperty.brand.code}/projects/${selectedProperty.property_code}/unit-details/${building.building_code}`}
                              >
                                <span>{building.building_code}</span>
                              </NavLink>
                            </Menu.Item>
                          )
                        )
                        : null}
                    </SubMenu>
                    <Menu.Item style={{ backgroundColor: '#1f3c88' }}>
                      <span>  {project.pdf ? (
                        <a
                          href="/"
                          href={project.pdf}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: 'white', opacity: 0.8,
                            display: 'block',
                          }}
                        > Download PDF
                        </a>
                      ) : null}
                      </span>
                    </Menu.Item>
                  </Menu>
                  {/* <div className="sider-action-buttons">
                    {project.pdf ? (
                      <a
                        href="/"
                        href={project.pdf}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Button ghost>Download PDF</Button>
                      </a>
                    ) : null}

                    <Link
                      to={`/dashboard/brands/ZRCO/projects/40036/availability`}
                    >
                      <Button className="availability-check hide">
                        Check Availability
                      </Button>
                    </Link>
                  </div> */}
                </Sider>
              ) : null}
              <Content>
                {React.cloneElement(this.props.children, { ...this.props })}
              </Content>
            </Layout>
          </Layout>
          <Modal
            title="Signout"
            visible={this.state.logoutVisible}
            onOk={this.onOk}
            onCancel={this.hideModal}
            okText="Ok"
            cancelText="Cancel"
          >
            <p>Are you sure you want to signout?</p>
          </Modal>
          <ChangePassword
            ifLoginPage={false}
            isClear={this.state.isClear}
            isChangingPassword={this.props.isChangingPassword}
            modalVisible={this.state.changePasswordModal}
            handleModaTermsVisible={this.cancelChangeModal}
            handleCloseTerms={this.cancelChangeModal}
            handleSubmitPassword={this.handeSubmitChangePassword}
          />
        </Layout>
      );
    }

    return (
      <div className="app">
        <main className="main">
          <Layout id="auth">
            <Content>
              <div>{this.props.children}</div>
            </Content>
            {/* <Footer>
              <Row className="text-center auth-footer">
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 24 }}
                  lg={{ span: 8 }}
                >
                  <img src="/assets/images/logo.png" alt="logo" />
                </Col>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 24 }}
                  lg={{ span: 8 }}
                >
                  <p style={{ margin: "10px 0 6px" }}>
                    <Link to="/">PRIVACY POLICY</Link> /{" "}
                    <Link to="/">TERMS & CONDITIONS</Link> /{" "}
                    <Link to="/">CONTACT US</Link>
                  </p>
                </Col>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 24 }}
                  lg={{ span: 8 }}
                  className="footer-socials"
                >
                  <Link to="/">
                    <Icon
                      type="facebook"
                      theme="outlined"
                      style={{ color: "#1E417B", fontSize: "2em" }}
                    />
                  </Link>

                  <Link to="/">
                    <Icon
                      type="twitter"
                      theme="outlined"
                      style={{ color: "#1E417B", fontSize: "2em" }}
                    />
                  </Link>

                  <Link to="/">
                    <Icon
                      type="youtube"
                      theme="outlined"
                      style={{ color: "#1E417B", fontSize: "2em" }}
                    />
                  </Link>
                </Col>
              </Row>
            </Footer> */}
          </Layout>
        </main>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(themeActionCreators, dispatch),
  ...bindActionCreators(authCreators, dispatch)
});

const mapStateToProps = (state, ownState) => ({
  isAuthenticated: state.auth.isAuthenticated,
  selectedTheme: state.theme.selectedTheme,
  selectedMenu: state.theme.selectedMenu,
  selectedSubMenu: state.theme.submenu,
  selectedProperty: state.cmsHoc.selectedProperty,
  isChangingPassword: state.auth.isChangingPassword,
  changePasswordData: state.auth.changePasswordData,
  profile: state.profile.profile,
  isCustomer: state.auth.isCustomer
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
